var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_1373)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81349 5.29861C3.81349 4.76305 4.25042 4.32611 4.78599 4.32611H9.83356V4.32614V16.7299H7.49149C7.1253 16.7299 6.82843 17.0267 6.82843 17.3929C6.82843 17.7591 7.1253 18.056 7.49149 18.056H12.4247C12.7909 18.056 13.0877 17.7591 13.0877 17.3929C13.0877 17.0267 12.7909 16.7299 12.4247 16.7299H11.1597V4.32614V4.32611H16.2083C16.7439 4.32611 17.1808 4.76305 17.1808 5.29861V6.63357C17.1808 6.99976 17.4777 7.29663 17.8439 7.29663C18.2101 7.29663 18.5069 6.99976 18.5069 6.63357V5.29861C18.5069 4.03065 17.4763 3 16.2083 3H4.78599C3.51802 3 2.48737 4.03065 2.48737 5.29861V6.63357C2.48737 6.99976 2.78423 7.29663 3.15043 7.29663C3.51663 7.29663 3.81349 6.99976 3.81349 6.63357V5.29861ZM13.4849 9.86938C13.1187 9.86938 12.8218 10.1662 12.8218 10.5324C12.8218 10.8986 13.1187 11.1955 13.4849 11.1955H14.9439V19.6738H13.7154C13.3492 19.6738 13.0523 19.9707 13.0523 20.3369C13.0523 20.7031 13.3492 21 13.7154 21H17.4992C17.8654 21 18.1623 20.7031 18.1623 20.3369C18.1623 19.9707 17.8654 19.6738 17.4992 19.6738H16.27V11.1955H19.6823C19.9615 11.1955 20.1863 11.4202 20.1863 11.6994V12.4067C20.1863 12.7729 20.4831 13.0697 20.8493 13.0697C21.2155 13.0697 21.5124 12.7729 21.5124 12.4067V11.6994C21.5124 10.6878 20.6939 9.86938 19.6823 9.86938H13.4849Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_1373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/textIcon.d2d1b8de.svg";
export { ForwardRef as ReactComponent };